<template>
  <div class="mgui-alert">
    <div class="mgui-alert-inner">
      <transition-group name="mgui-alert" tag="p" 
        v-on:enter="alertEnter"
        v-on:after-leave="alertLeave">
        <template v-for="(item, key) in items">
          <div class="mgui-alert-item" :key="key">
            <svg class="icon mgui-alert-close" aria-hidden="true" @click="remove(item)">
              <use xlink:href="#icon-guanbi"></use>
            </svg>
            <h2>{{jsonItem(item).title}}</h2>
            <p>{{jsonItem(item).message}}</p>
          </div>
        </template>
      </transition-group>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Alerts',
  props: {
  },
  data () {
    return {
      items: []
    }
  },
  watch: {
  },
  mounted () {
    this.items = this.$store.state.alerts
  },
  methods: {
    close () {
      this.visible = false
    },
    jsonItem (item) {
      return JSON.parse(item)
    },
    remove: function (item) {
      this.items.splice(this.items.indexOf(item), 1)
    },
    shuffle: function () {
      // this.items = this.items.shuffle(this.items)
    },
    alertEnter () {
      // setTimeout(() => {
      //   this.items.splice(this.items.length - 1, 1)
      // }, 3500)
    },
    alertLeave () {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mgui-alert{
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1010
  }
  .mgui-alert-inner{
    width: 200px;
    position: absolute;
    top: 0;
    right: 0;
    z-index:1011;
  }
  .mgui-alert-item{
    width: 200px;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    position: relative;
    right: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4)
  }
  .mgui-alert-item h2{
    font-size: 12px;
    color: #f00;
    margin-bottom: 5px;
  }
  .mgui-alert-item p{
    font-size: 14px;
    margin: 0;
  }
  .mgui-alert-item {
    transition: all 1s;
    display: block;
    margin-bottom: 10px;
  }
  .mgui-alert-enter, .mgui-alert-leave-to
  /* .mgui-alert-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(100%);
  }
  .mgui-alert-leave-active {
    position: absolute;
  }

  .mgui-alert-close{
    position: absolute;
    right: 10px;
    top: 10px;
    transition: .5s 0s all ease;
    -webkit-transition: .5s 0s all ease;
  }
  .mgui-alert-close:hover{
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  /*.bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }*/
</style>
